import { useState, useContext, useEffect } from "react";
import {
  Button,
  Grid,
  Typography,
  Dialog,
  CircularProgress,
} from "@mui/material";

import { Http, appLogger } from "../../../utils";

import { UserContext } from "../../../context/userContext";
import { UserLoginInfo } from "../../../types/context";

import { useParams } from "react-router-dom";

interface IProps {
  open: boolean;
  onClose: () => void;
  handleFetchStoredDocuments: () => void;
  selectedFolder: any;
}

const ConfirmDeleteModal = ({
  open,
  onClose,
  selectedFolder,
  handleFetchStoredDocuments,
}: IProps) => {
  const { productId, versionId } = useParams();
  const { userInfo } = useContext(UserContext) as UserLoginInfo;

  const [usedKnowledgeBaseIds, setUsedKnowledgeBaseIds] = useState<string[]>(
    []
  );

  const [loading, setLoading] = useState(false);

  const handleFetchProduct = async () => {
    setLoading(true);
    try {
      const res: any = await Http.get({
        url: `/api/v2/products/${productId}/${versionId}`,
      });

      if (res?.products?.[0]?.chatAgentSettings) {
        const productRes = res.products[0];
        const { chatAgentSettings = {} } = productRes;
        const { aiSetting } = chatAgentSettings;

        const tempArticleIds = aiSetting.kbArticles.map(
          (article: any) => article.id
        );

        setUsedKnowledgeBaseIds(tempArticleIds);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      appLogger.error({
        errObj: {
          method: "handleFetchProduct",
          component: "ConfirmDeleteModal",
          fileName: "ConfirmDeleteModal.tsx",
          err: err,
        },
      });
    }
  };

  const handleDeleteDocument = async (id: string) => {
    try {
      await Http.deleteReq({
        url: `/api/v2/kbArticles/${id}`,
        state: userInfo,
      });

      handleFetchStoredDocuments();
      onClose();
    } catch (err) {
      appLogger.error({
        errObj: {
          method: "handleDeleteDocument",
          component: "ConfirmDeleteModal",
          fileName: "ConfirmDeleteModal.tsx",
          err: err,
        },
      });
    }
  };

  useEffect(() => {
    handleFetchProduct();
  }, []);

  return (
    <Dialog open={open} onClose={onClose} title="Delete knowledgebase">
      <Grid
        container
        sx={{
          padding: "10px",
        }}
      >
        <Grid item xs={12}>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "18px",
            }}
          >
            Delete knowledgebase
          </Typography>
        </Grid>
      </Grid>
      {loading && (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{
            minWidth: "500px",
            minHeight: "150px",
          }}
        >
          <CircularProgress size={30} />
        </Grid>
      )}
      {!loading && (
        <Grid
          container
          justifyContent="center"
          sx={{
            padding: "30px",
          }}
        >
          {usedKnowledgeBaseIds.includes(selectedFolder.id) && (
            <Grid item xs={12} textAlign="center">
              <Typography
                sx={{
                  fontSize: "18px",
                }}
              >
                This Knowledgebase is currently in use by the Chatbot.
              </Typography>
              <Typography
                sx={{
                  fontSize: "18px",
                }}
              >
                Are you sure you want to delete it?
              </Typography>
            </Grid>
          )}

          {!usedKnowledgeBaseIds.includes(selectedFolder.id) && (
            <Grid item xs={12} textAlign="center">
              <Typography
                sx={{
                  fontSize: "18px",
                }}
              >
                Are you sure you want to delete this knowledgebase?
              </Typography>
            </Grid>
          )}
          <Grid
            container
            justifyContent="center"
            gap="15px"
            item
            xs={12}
            mt="15px"
          >
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                handleDeleteDocument(selectedFolder.id);
              }}
            >
              Confirm
            </Button>
          </Grid>
        </Grid>
      )}
    </Dialog>
  );
};

export default ConfirmDeleteModal;
